import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const PrimaryHoverEffectBox = styled(Box)`
  position: relative;
  text-align: center;
  ::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    display: none;
    padding: 0;
    height: ${(props) => (props.heighteffect ? props.heighteffect + "px" : "110%")};
    width: 100%;
    background-color: ${({ theme }) => theme.palette.grey.g6} !important;
    transform: translate(10%, -50%);
    border-top-left-radius: 1.1em;
    border-bottom-left-radius: 1.1em;
  }
  &.active::after {
    display: block;
    max-width: 60px;
    filter: drop-shadow(0px 2px 5px ${({ theme }) => theme.palette.grey.g2});
    background-color: ${({ theme }) => theme.palette.grey.g6} !important;
    box-shadow: ${({ theme }) => theme.shadows.light} !important;
  }
  > button:hover {
    padding: 8px;
    border-radius: 2em;
    background-color: ${({ theme }) => alpha(theme.palette.primary.main, 0.12)};
    max-height: 37px;
  }
  > * {
    z-index: 1;
  }
`;
